"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ProvidersStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/ProvidersStage.vue"));
const BridgeStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/BridgeStage.vue"));
const onSuccessfulCallStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/onSuccessfulCallStage.vue"));
const onErrorCallStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/onErrorCallStage.vue"));
const DisconnectionWarning_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/DisconnectionWarning.vue"));
const BlockList_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/BlockList.vue"));
const FetchingStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/FetchingStage.vue"));
const ImportingDataStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/ImportingDataStage.vue"));
const onSuccessfulImportStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/onSuccessfulImportStage.vue"));
const onFailedImportStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/onFailedImportStage.vue"));
const DisclaimerStage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Stages/DisclaimerStage.vue"));
let ThirdPartiesModal = class ThirdPartiesModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.noDismissableStages = ['bridge', 'fetching', 'importingData'];
        this.selectedBlocks = [];
        this.myCustomClass = 'bmfw-modal-third-parties';
    }
    buildCustomClass() {
        let base = 'bmfw-modal-third-parties';
        if (this.noDismissableStages.includes(this.activeStage))
            base = 'bmfw-modal-third-parties--no_dismissable';
        this.myCustomClass = base;
    }
    dismissModal() {
        if (!this.noDismissableStages.includes(this.activeStage)) {
            this.$emit('dismissModal');
        }
    }
    jumpToMap() {
        window.location.href = window.location.href + '&showingArea=' + this.activeArea.meta.id;
    }
    refresh() {
        window.location.reload();
    }
    connectProvider(p) {
        this.$emit('connectProvider', p, this.activeArea.meta.id);
    }
    confirmConnection(p) {
        this.$emit('confirmConnection', p, this.activeArea.meta.id);
    }
    disconnectProvider(p) {
        this.$emit('disconnectProvider', p);
    }
    confirmDisconnection(p) {
        this.$emit('confirmDisconnection', p);
    }
    listProvider(p) {
        this.$emit('listProvider', p);
    }
    backToList() {
        this.$emit('backToList');
    }
    afterConnection() {
        this.$emit('afterConnection');
    }
    backToBlocks() {
        this.$emit('backToBlocks');
    }
    addSelected(b) {
        this.selectedBlocks = b;
        this.$emit('addSelected', b);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ThirdPartiesModal.prototype, "providers", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'list' })
], ThirdPartiesModal.prototype, "activeStage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ThirdPartiesModal.prototype, "activeProvider", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'connect' })
], ThirdPartiesModal.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'area' })
], ThirdPartiesModal.prototype, "importMode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ThirdPartiesModal.prototype, "message", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ThirdPartiesModal.prototype, "activeArea", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ThirdPartiesModal.prototype, "activeProviderAreas", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ThirdPartiesModal.prototype, "isConnection", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ThirdPartiesModal.prototype, "isDisclaimerTriggerable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('activeStage')
], ThirdPartiesModal.prototype, "buildCustomClass", null);
ThirdPartiesModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            BridgeStage: BridgeStage_vue_1.default,
            ProvidersStage: ProvidersStage_vue_1.default,
            onSuccessfulCallStage: onSuccessfulCallStage_vue_1.default,
            onErrorCallStage: onErrorCallStage_vue_1.default,
            DisconnectionWarning: DisconnectionWarning_vue_1.default,
            BlockList: BlockList_vue_1.default,
            FetchingStage: FetchingStage_vue_1.default,
            ImportingDataStage: ImportingDataStage_vue_1.default,
            onSuccessfulImportStage: onSuccessfulImportStage_vue_1.default,
            onFailedImportStage: onFailedImportStage_vue_1.default,
            DisclaimerStage: DisclaimerStage_vue_1.default
        },
        emits: ['dismissModal', 'connectProvider', 'disconnectProvider', 'listProvider', 'confirmDisconnection', 'backToList', 'addSelected', 'backToBlocks', 'confirmConnection', 'afterConnection'],
    })
], ThirdPartiesModal);
exports.default = ThirdPartiesModal;
